import classNames from "classnames";

import type { Podcast as PodcastType } from "lib/types/podcasts";
import BlurUpImage from "components/blurUpImage/blurUpImage";

type PodcastProps = PodcastType & {
  onLinkClick: (podcast: PodcastType) => Promise<void>;
};

export const Podcast = ({ onLinkClick, ...props }: PodcastProps) => {
  const { name, description, link, image } = props;

  return (
    <div className="flex flex-row gap-[48px] max-lg:items-center max-md:flex-wrap max-md:justify-center md:gap-[32px]">
      <div className={"h-[250px] w-[250px] flex-none"}>
        <BlurUpImage
          src={image.url}
          alt={image.alt}
          width={image.width}
          height={image.height}
          sizes={"(max-width: 768px) 100vw,  (max-width: 1200px) 50vw, 33vw"}
        />
      </div>
      <div className="flex flex-col justify-between md:my-6 lg:my-0">
        <div className={"flex flex-col gap-[16px] md:gap-[24px]"}>
          <h2 className={"font-bold text-[24px] leading-tight md:text-[28px]"}>
            {name}
          </h2>
          <div
            className={"mb-4 max-w-[600px] leading-tight md:mb-6"}
            dangerouslySetInnerHTML={{ __html: description }}
          />
        </div>
        <div className="max-md:text-center">
          <a
            className={classNames(
              "inline-block w-auto [line-height:80%]",
              "bg-[#DA145E] text-[#FFFFFF] hover:bg-[#c60f53] hover:text-[#FFFFFF]",
              "focus:outline-none focus:ring focus:ring-[#8F033B] active:bg-[#DA145E] disabled:bg-[#DDDDDD] disabled:text-[#5B5B5B]",
              "rounded-full font-bold duration-200 ease-in-out",
              "px-[32px] py-[14px] text-[18px]"
            )}
            href={link}
            referrerPolicy={"no-referrer"}
            rel={"noreferrer"}
            target={"_blank"}
            onClick={async () => await onLinkClick(props)}
          >
            Learn more
          </a>
        </div>
      </div>
    </div>
  );
};
